import { connect } from 'react-redux';
import { getApplications, resetMeta, resetPage } from '../../actions/ApplicationListPage';
import { resetPage as resetListPage } from '../../actions/ApplicationListPage';
import ApplicationListPage from './ApplicationListPage';

const mapsStateToProps = state => ({
	pageProps: state.applicationListPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getApplications(options) {
		dispatch(getApplications(options));
	},
	resetMeta() {
		dispatch(resetMeta());
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetListPage() {
		dispatch(resetListPage());
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(ApplicationListPage);
